import script from "./SnapshotsBackups.vue?vue&type=script&setup=true&lang=js"
export * from "./SnapshotsBackups.vue?vue&type=script&setup=true&lang=js"

import "./SnapshotsBackups.vue?vue&type=style&index=0&id=60e7be59&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60e7be59"]])

export default __exports__